<template>
  <v-app class="default-layout">
    <app-bar
      :navigation-links="navigationLinks"
      @logout="logout"
      @stop-impersonating="stopImpersonating"
    />
    <v-main class="main-container">
      <v-container
        class="main-container__content"
      >
        <app-error-messages />
      </v-container>
      <v-slide-x-reverse-transition mode="out-in">
        <div class="transition-wrapper">
          <div
            class="default-layout__wrapper position-relative"
          >
            <div class="default-layout__wrapper__content">
              <slot />
            </div>
          </div>
        </div>
      </v-slide-x-reverse-transition>
      <footer-info
        v-if="showFooter"
        class="mt-8"
      />
    </v-main>
    <app-drawer
      :navigation-links="navigationLinks"
      @logout="logout"
      @stop-impersonating="stopImpersonating"
    />
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import AppErrorMessages from "@/components/AppErrorMessages.vue"
import FooterInfo from "@/components/FooterInfo.vue"
import AppBar from "@/components/AppBar.vue"
import AppDrawer from "@/components/AppDrawer.vue"
import {useAppStore} from "@/stores/app"

interface Link {
  text: string
  to: string
  target?: string
  icon: string
  action?: () => void
  hr?: boolean
}

export default defineComponent({
  components: {FooterInfo, AppErrorMessages, AppDrawer, AppBar},
  computed: {
    navigationLinks() {
      let links: Link[] = []

      if(this.$auth.isGuest()) {
        links.push({
          text: 'Home',
          to: this.ROUTES.HOME,
          icon: 'mdi-home',
        })
      } else {
        if(this.$auth.isCompany()) {
          links.push({
            text: 'Dashboard',
            to: this.ROUTES.COMPANY_DASHBOARD,
            icon: 'mdi-view-dashboard',
          })
        }
        if(!this.$auth.isAdmin()) {
          links.push({
            text: 'Home',
            to: this.ROUTES.HOME,
            icon: 'mdi-home',
          })
        }
      }
      if(this.$auth.isAdmin()) {
        links.push({
          text: 'Users',
          to: this.ROUTES.USERS,
          icon: 'mdi-account-group',
        })
        links.push({
          text: 'Job Listings',
          to: this.ROUTES.JOB_LISTINGS,
          icon: 'mdi-briefcase',
        })
        links.push({
          text: 'Reviews',
          to: this.ROUTES.REVIEWS,
          icon: 'mdi-star',
        })
        links.push({
          text: 'Transactions',
          to: this.ROUTES.TRANSACTIONS,
          icon: 'mdi-cash',
        })
      } else {
        links.push({
          text: 'Find Talent',
          to: this.ROUTES.FIND_TALENT,
          icon: 'mdi-account-search',
        })
        links.push({
          text: 'Find Work',
          to: this.ROUTES.FIND_WORK,
          icon: 'mdi-briefcase-search',
        })
        links.push({
          text: 'Contact',
          to: this.ROUTES.CONTACT_US,
          icon: 'mdi-email',
        })
      }

      return links
    },
    showFooter() {
      return this.$route.name !== this.ROUTES.REGISTER
    }
  },
  methods: {
    async logout() {
      await this.$auth.logout()
      await this.$router.push(this.$routeTo(this.ROUTES.LOGIN))
      await this.$nextTick()
      const appStore = useAppStore()
      appStore.addSuccess("You have been logged out")
    },
    async stopImpersonating() {
      await this.$auth.stopImpersonating()
      const appStore = useAppStore()
      appStore.addSuccess('Stopped impersonating user')
      await this.$router.push(this.$routeTo(this.ROUTES.USERS))
    },
  },
})
</script>

<style lang="scss" scoped>
.transition-wrapper {
  min-height: calc(100vh - 434px);
}
</style>
